import { Button } from '@paulownia/shared/components/ui/button';
import { Card } from '@paulownia/shared/components/ui/card';
import { ArrowLeft } from 'lucide-react';
import type { TenantNotFoundProps } from './types';

const funnyMessages = [
    "On dirait que ce poulet s'est envolé de la rôtisserie...",
    "Cette adresse est aussi vide qu'un plat après un dimanche en famille.",
    "Erreur 404 : Poulet introuvable. Il a dû s'échapper avant la cuisson.",
    "Ce commerçant est plus discret qu'une recette secrète de grand-mère.",
    "Oups ! Ce stand de marché n'existe pas... ou il est parti en pause déjeuner.",
];

export function TenantNotFound({ slug, onBackClick }: TenantNotFoundProps) {
    const randomMessage = funnyMessages[Math.floor(Math.random() * funnyMessages.length)];

    return (
        <div className="min-h-screen bg-gradient-to-b from-orange-50 to-white flex items-center justify-center p-4">
            <Card className="w-full max-w-md text-center p-8 shadow-xl">
                {/* Animated chicken emoji */}
                <div className="text-8xl mb-6 animate-bounce">
                    🐔
                </div>

                <h1 className="text-3xl font-bold text-gray-900 mb-2">
                    Page introuvable !
                </h1>

                <p className="text-lg text-gray-600 mb-6">
                    {randomMessage}
                </p>

                <div className="bg-orange-50 rounded-lg p-4 mb-6 border border-orange-200">
                    <p className="text-sm text-orange-700">
                        <span className="font-semibold">L'adresse demandée :</span>
                        <br />
                        <code className="text-orange-900 bg-orange-100 px-2 py-1 rounded mt-1 inline-block">
                            /{slug}
                        </code>
                        <br />
                        <span className="text-orange-600 mt-2 block">n'existe pas ou n'est plus disponible.</span>
                    </p>
                </div>

                <Button
                    size="lg"
                    className="w-full text-lg h-14 bg-orange-600 hover:bg-orange-700"
                    onClick={onBackClick}
                >
                    <ArrowLeft className="w-5 h-5 mr-2" />
                    Retour à l'accueil
                </Button>

                <p className="text-xs text-gray-400 mt-6">
                    Si vous pensez qu'il s'agit d'une erreur, contactez le commerçant.
                </p>
            </Card>
        </div>
    );
}
